// import { initStickyHeader } from "../component/header.js";
import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initSlimSelects } from "../component/custom-select.js";
import { equalHeight } from "../component/equal-height.js";
import { initCategorySearch } from "../component/listing-category-redirection.js";
import { initNewsletterModal } from "../component/custom-newsletter-popup.js";
import {
  initCookieBar,
  initDmcabadge,
  initGooglePreferredSource,
} from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initGlowWrapper } from "../component/glow.js";

initDmcabadge();
initCookieBar();
initGooglePreferredSource();
initSlimSelects();
initOfficeHoverReveal();
initSlimSelects();
initCategorySearch();
initMobileMenu();
initNewsletterModal();

const updateEqualHeight = () => {
  equalHeight(
    ".blog-grid-wrapper .blog-grid-row .blog-grid-content-wrapper .content-block h2",
  );
};

window.updateEqualHeight = updateEqualHeight;
updateEqualHeight();

window.addEventListener("load", () => {
  updateEqualHeight();
});

window.addEventListener("resize", () => {
  updateEqualHeight();
});

document.addEventListener("DOMContentLoaded", () => {
  initGlowWrapper();
});

// window.addEventListener("DOMContentLoaded", () => {
//   initNewsletterModal();
// });